import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dateSelectionToggle",
    "dateVotingMultipleContainer",
    "dateVotingMultipleInput",
    "dateVotingDeadlineContainer",
    "dateVotingDeadlineInput",
    "startsOnInput"
  ]

  connect() {
    this.updateDateVotingVisibility()
  }

  toggleDateSelection() {
    this.updateDateVotingVisibility()
  }

  updateDateVotingVisibility() {
    if (!this.hasDateSelectionToggleTarget) return

    const enabled = this.dateSelectionToggleTarget.checked

    if (this.hasDateVotingMultipleContainerTarget) {
      this.dateVotingMultipleContainerTarget.classList.toggle("hidden", !enabled)
    }
    if (this.hasDateVotingMultipleInputTarget) {
      this.dateVotingMultipleInputTarget.disabled = !enabled
      if (!enabled) this.dateVotingMultipleInputTarget.checked = false
    }

    if (this.hasDateVotingDeadlineContainerTarget) {
      this.dateVotingDeadlineContainerTarget.classList.toggle("hidden", !enabled)
    }
    if (this.hasDateVotingDeadlineInputTarget) {
      this.dateVotingDeadlineInputTarget.disabled = !enabled
      if (!enabled) this.dateVotingDeadlineInputTarget.value = ""
    }

    if (this.hasStartsOnInputTarget) {
      this.startsOnInputTarget.disabled = enabled
    }
  }
}
